/* 2.11 (uwagi Łukasza PROD-002): galeria karty produktu zależna od rozmiaru.
   Zdjęcia mają rozmiar w alt („… XS_ …”, „… M_ …”; packshoty M wgrane 2.11 skryptem tools/studio/size_packshots_0211.py).
   Gdy produkt ma co najmniej 2 takie grupy: po wyborze rozmiaru zostają zdjęcia tej grupy + zdjęcia bez znacznika;
   S bez własnych zdjęć → zestaw M (wskazanie Łukasza). Produkty bez znaczników — bez zmian. */
(function () {
  var RX = /\b(XXS|XS|S|M|L|XL)_/, ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL'];
  function grp(el) { var i = el && el.querySelector('img'); var m = i && (i.getAttribute('alt') || '').match(RX); return m ? m[1] : null; }
  function run() {
    var page = document.querySelector('.product__page') || document;
    var slides = Array.prototype.slice.call(page.querySelectorAll('.product__slide'));
    var groups = {};
    slides.forEach(function (s) { var g = grp(s); s.__slSz = g; if (g) groups[g] = 1; });
    var have = ORDER.filter(function (s) { return groups[s]; });
    if (have.length < 2) return;
    var thumbs = Array.prototype.slice.call(page.querySelectorAll('.product__thumb'));
    var byId = {};
    slides.forEach(function (s) { if (s.dataset.mediaId) byId[s.dataset.mediaId] = s.__slSz; });
    function size() {
      var r = Array.prototype.filter.call(page.querySelectorAll('input[type=radio]:checked'), function (i) { return /rozmiar|size|gr[oö]ße|taille|maat|розмір/i.test(i.name); })[0];
      return r ? r.value.split(/[\s·]/)[0].toUpperCase() : null;
    }
    function apply() {
      var s = size(); if (ORDER.indexOf(s) < 0) return;
      var t = groups[s] ? s : (have.filter(function (x) { return ORDER.indexOf(x) > ORDER.indexOf(s); })[0] || have[have.length - 1]);
      slides.forEach(function (sl) { sl.classList.toggle('sl-sz-hide', !!sl.__slSz && sl.__slSz !== t); });
      thumbs.forEach(function (th) {
        var a = th.querySelector('[data-media-id]'); var g = a ? byId[a.dataset.mediaId] : grp(th);
        th.classList.toggle('sl-sz-hide', !!g && g !== t);
      });
    }
    apply();
    page.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') setTimeout(apply, 30); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
